import React, { useEffect } from "react";
import "./assets/css/App.css";
import AOS from "aos";
import "aos/dist/aos.css";
import Lenis from "lenis";
import "lenis/dist/lenis.css";

const App = () => {

  useEffect(() => {
    const lenis = new Lenis({
      duration: 3,
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 2,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000
    });
  }, []);

  return (
    <div className="AiParentContainer">
      <div className="IqqraAIHomeContainer">
        <video
          className="homeVideo"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src="Home.mp4" type="video/mp4" />
        </video>

        <div className="IqqraAIHomeTextContainer1">
          <h4 className="HomeTitle1">IQQRA.AI</h4>
        </div>

        <div className="IqqraAIHomeTextContainer2">
          <h1 className="HomeTitle2">AI</h1>
          <h1 className="HomeTitle2">for</h1>
          <h1 className="HomeTitle2">Facility Management</h1>
        </div>
      </div>
    </div>
  );
};

export default App;
